import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { MASKS } from 'ng-brazil';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';

@Component({
  selector: 'app-volume-modal',
  templateUrl: './volume-modal.component.html',
  styleUrls: ['./volume-modal.component.scss']
})
export class VolumeModalComponent implements OnInit {

  public config: PerfectScrollbarConfigInterface = {};

  volume;
  dimensao;
  peso;
  idCupom = '';

  public MASKS = MASKS;


  constructor(public dialogRef: MatDialogRef<VolumeModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit() {
    this.idCupom = this.data.idCupom;
    this.peso = this.data.peso;
  }

  conferir() {
    this.dialogRef.close({ volume: this.volume, dimensao: this.dimensao, peso: this.peso });
  }

  fechar() {
    this.dialogRef.close();
  }

}
